import React, { Children } from 'react';
import styles from './radio.scss';
import groupStyle from '../group.scss';
import commonStyles from '../common.scss';

import { FormField } from '../form-field';
import FieldNote from 'ui/form/field-note/field-note';
import FieldLabel from 'ui/form/field-label';

import { RadioGroupFieldProps } from 'ui/form/fields';
import { REQUIRED } from 'ui/form/constants';
import { isValue } from '../utils';

interface RadioGroupFieldState {
  errors: boolean | string;
}

export default class RadioGroup extends FormField<RadioGroupFieldProps, RadioGroupFieldState> {
  static getDerivedStateFromProps({ error: nextError }, { errors: prevError }) {
    if (!prevError && nextError) return { errors: nextError };

    return null;
  }

  static get defaultValue() {
    return '';
  }
  
  static getErrors(props: RadioGroupFieldProps, formData) {
    const value = isValue(props.value) ? props.value : (formData || {})[props.name];
    if (!isValue(value) && props.required) return REQUIRED;
    
    return false;
  }

  state = {
    errors: false
  };

  validate() {
    const errors = RadioGroup.getErrors();
    this.setState({ errors });
    
    return !errors;
  }

  handleChange = change => {
    const { onChange } = this.props;

    this.setState({ errors: false });
    if (onChange) onChange(change);
  };

  render() {
    const { children, label, name, required, value, row } = this.props;
    const { errors } = this.state;
    
    let { help } = this.props;
    if (required) help = help || REQUIRED;
    
    const items = [];
    Children.forEach(children, (child, index) => {
      items.push(
        <child.type
          key={name + child.props.value + index}
          index={index}
          {...child.props}
          name={name}
          onChange={this.handleChange}
          checked={isValue(child.props.value) && isValue(value) && value === child.props.value}
        />
      );
    });

    const cl = [commonStyles.field];
    cl.push(errors ? styles.error : styles.holder);

    return (
      <div className={cl.join(' ')}>
        {!row ? (
          <div
            className={styles.group + ' ' + groupStyle.root}
            style={{ paddingBottom: help || errors ? 0 : 3 }}>
            <FieldLabel label={label} error={errors} style={{ paddingLeft: 12 }} />
            {!name && <div className="text-error">Radio group must have name attribute</div>}
            {items}
            {(help || errors) && <FieldNote note={help} error={errors} />}
          </div>
        ) : (
          <div>
            <FieldLabel label={label} error={errors} style={{ paddingLeft: 12 }} />
            <div
              className={styles.group + ' ' + groupStyle.root}
              style={{
                paddingBottom: help || errors ? 0 : 3,
                display: 'flex',
                padding: '10px',
                marginTop: '10px',
                marginBottom: 0,
                flexWrap: 'wrap',
                justifyContent: 'space-between'
              }}>
              {items}
            </div>
            {(help || errors) && <FieldNote note={help} error={errors} />}
          </div>
        )}
      </div>
    );
  }
}
